<template>
  <div @click="clickDiv" style="display: flex;flex-direction: row;align-items: center">
    <div :style="hcf.getTextStyle(
            {
            color:moneyColor??'main',marginTop:4,fontWeight:'bold',marginRight:3,addSize:moneySize??0}
            )">
      ¥
    </div>
    <div :style="hcf.getTextStyle(
            {
              color:moneyColor??'main',fontWeight:'bold',addSize:moneySize?moneySize+5:5}
            )">
      {{useUser.totalMoney.length>8?useUser.totalMoney.split('.')[0]:useUser.totalMoney}}
    </div>
    <HRotateImg ref="rotateImgRef" :clickImg="()=>{useHComApi().refreshUserBalance({isShowToast:true})}" :width="imgSize??22" :height="imgSize??22" style="margin-left:5px;"/>
  </div>
</template>


<script setup>
  import {useUserStore} from "@/stores/useUser.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {hcf} from "@/components/utils/HComFunctions.js";

  const useUser = useUserStore();
  defineProps(["moneyColor","moneySize","imgSize"]);

  const rotateImgRef = ref();
  function clickDiv(){
    rotateImgRef.value.pressRotateImg();
  }
</script>


<style scoped>
</style>
